import { useHandler } from "@redotech/react-util/hook";
import {
  DateComparisonOperator,
  dateComparisonOperators,
  dateComparisonToLabel,
} from "@redotech/redo-model/advanced-flow/expressions/date-expression";
import {
  OmsCustomAttributeDate1ConditionStep,
  OmsCustomAttributeDate2ConditionStep,
  OmsCustomAttributeDate3ConditionStep,
  OmsCustomDate1ConditionStep,
  OmsCustomDate2ConditionStep,
  OmsCustomDate3ConditionStep,
} from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { memo } from "react";
import { DeepPartial } from "..";
import { DateMatchKindSelect } from "../common/date-match-kind-select";

const dateCompareOptions: RedoListItem<DateComparisonOperator>[] =
  dateComparisonOperators.map((type) => ({
    value: type,
    type: "text",
    id: type,
    text: dateComparisonToLabel[type],
  }));

export const OmsDateMatchTypeSelect = memo(function OmsDateMatchTypeSelect({
  setStep,
  step,
}: {
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
  step:
    | DeepPartial<OmsCustomDate1ConditionStep>
    | DeepPartial<OmsCustomDate2ConditionStep>
    | DeepPartial<OmsCustomDate3ConditionStep>
    | DeepPartial<OmsCustomAttributeDate1ConditionStep>
    | DeepPartial<OmsCustomAttributeDate2ConditionStep>
    | DeepPartial<OmsCustomAttributeDate3ConditionStep>;
}) {
  const setMatchType = useHandler((item: DateComparisonOperator) => {
    setStep({ ...step, matchType: item });
  });
  return (
    <DateMatchKindSelect<DateComparisonOperator>
      options={dateCompareOptions}
      selectedMatchKind={step.matchType}
      setMatchKind={setMatchType}
    />
  );
});
